/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint-disable max-depth */
/* eslint-disable complexity */
/* eslint-disable newline-per-chained-call */
import ConciliationImport from './conciliation-import';
import ConciliationOperations from './conciliation-operations';
import ConciliationResume from './conciliation-resume';
import ConciliationTransfers from './conciliation-transfers';
import commonFunctions from './common-functions';

export default {
    name: 'Conciliation',
    extends: commonFunctions,

    components: {
        ConciliationTransfers,
        ConciliationOperations,
        ConciliationResume,
        ConciliationImport
    },

    data() {
        return {
            loading: false,
            transfers: [],
            operations: [],
            remainingTransactions: {},
            remainingOperations: {},
            operationsSelected: [],
            keyUpdateOperations: 0,
            keyUpdateTransfers: 0,
            heightResume: null,
            showModal: false,
            modalId: 'import_files',
            transferFilter: 'all',
            operationsFilter: 'all',
            monitorType: 'all',
            transferSort: {
                sortBy: 'transaction_date',
                sortDesc: true
            },
            operationsSort: {
                sortBy: 'request_date',
                sortDesc: true
            },
            transfersColumnFilters: {
                transaction_date: '',
                key_product: '',
                concept: '',
                gross_amount: ''
            },
            operationsColumnFilters: {
                request_date: '',
                name_product: '',
                gross_amount: ''
            }
        };
    },

    beforeMount() {
        this.loading = true;
    },

    mounted() {
        this.$root.$on('fetch_data', this.fetchData);
        this.$root.$on('filter_transactions', this.filterTransactions);
        this.$root.$on('filter_operations', this.filterOperations);
        this.$root.$on('set_operations', this.setOperationsList);
        this.$root.$on('set_transfers', this.setTransfersList);
        this.$root.$on('more_transactions', this.moreTransactions);
        this.$root.$on('more_operations', this.moreOperations);
        this.$root.$on('height_resume', this.setHeightResume);
        this.$root.$on('get_operations_suggested', this.getOperationsSuggested);
        this.$root.$on('get_transfers_suggested', this.getTransfersSuggested);
        this.$root.$on('filter_columns_transactions', this.filterColumnsTransactions);
        this.$root.$on('filter_columns_operations', this.filterColumnsOperations);

        this.fetchData();
    },

    methods: {
        getMarginToConciliate() {
            this.$usersService.getConfigVarByKey('MARGIN_RECONCILIATION')
                .then(res => {
                    this.$store.dispatch('conciliationStore/setMargin', Number(res.data.configuration.value));
                });
        },

        async loadTransactions(filterToApply) {
            try {
                const transactionsParams = {
                    $limit: 15,
                    $expand: 'reconciliation'
                };

                transactionsParams['$filter'] = JSON.stringify(filterToApply);
                const directionTransfers = this.transferSort.sortDesc ? 'desc' : 'asc';
                transactionsParams['$orderby'] = `${this.transferSort.sortBy} ${directionTransfers}`;

                const res = await this.$paymentsService.getTransactions({
                    params: transactionsParams
                });
                this.transfers = res.data.transactions;
                this.transfers.metadata = res.metadata;
                this.keyUpdateTransfers++;
            } catch (error) {
                this.$toast.error('Error', error);
            }
        },

        async loadOperations(filterToApply) {
            try {

                const operationsParams = {
                    $limit: 15,
                    $expand: 'reconciliation,bank_accounts,interveners,from_reconciliation'
                };
                operationsParams['$filter'] = JSON.stringify(filterToApply);

                const directionOperations = this.operationsSort.sortDesc ? 'desc' : 'asc';
                operationsParams['$orderby'] = `${this.operationsSort.sortBy} ${directionOperations}`;

                const res = await this.$operationsService.getOperations('', { params: operationsParams });

                this.operations = res.data.operations;
                this.operations.metadata = res.metadata;
                this.keyUpdateOperations++;
            } catch (error) {
                this.$toast.error('Error', error);
            }
        },

        fetchData() {

            // this.getMarginToConciliate();

            const endpoints = [
                this.$paymentsService.getRemainingTransactions(),
                this.$paymentsService.getRemainingOperations()
            ];

            const filterToApply = {
                has_completed_reconciliation: [
                    { eq: false }
                ]
            };
            const searchBy = this.$store.getters['conciliationStore/searchBy'];
            if (searchBy === 'transfers') {
                endpoints.push(this.getOperationsSuggested());
                endpoints.push(this.loadTransactions(filterToApply));
            } else if (searchBy === 'operations') {
                endpoints.push(this.getTransfersSuggested());
                endpoints.push(this.loadOperations(filterToApply));
            } else {
                endpoints.push(this.loadTransactions(filterToApply));
                endpoints.push(this.loadOperations(filterToApply));
            }
            Promise.all(endpoints)
                .then(res => {
                    this.remainingTransactions = res[0].data;
                    this.remainingOperations = res[1].data;
                })
                .catch(error => {
                    this.$toast.error('Error', error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        filterTransactions(filter, sort) {
            if (filter !== false) {
                this.transferFilter = filter;
            }

            let filterToApply = {};
            switch (this.transferFilter) {
                case 'historic':
                    filterToApply = {
                        reconciliation_status: [
                            { eq: 'CONCILIADO' }
                        ],
                        has_completed_reconciliation: [
                            { eq: true }
                        ]
                    };
                    break;
                case 'preconciliado':
                    filterToApply = {
                        reconciliation_status: [
                            { eq: 'PRECONCILIADO' }
                        ]
                    };
                    break;
                case 'agrupadas':
                    filterToApply = {
                        has_completed_reconciliation: [
                            { eq: false }
                        ],
                        reconciliation_status: [
                            { or: '', eq: 'CONCILIADO' },
                            { eq: 'AGRUPADO' }
                        ]
                    };
                    break;
                case 'no-agrupadas':
                    filterToApply = {
                        reconciliation_status: [
                            { null: '' }
                        ]

                    };
                    break;
                default:
                case 'all':
                    filterToApply = {
                        has_completed_reconciliation: [
                            { eq: false }
                        ]
                    };
                    break;
            }

            for (const columnFilter in this.transfersColumnFilters) {
                if (this.transfersColumnFilters[columnFilter]) {
                    if (columnFilter === 'transaction_date') {
                        if (this.transfersColumnFilters[columnFilter].endDate && this.transfersColumnFilters[columnFilter].startDate) {
                            filterToApply[columnFilter] = [
                                { gte: `${this.$moment(this.transfersColumnFilters[columnFilter].startDate).format('YYYY/MM/DD')}` },
                                { lte: `${this.$moment(this.transfersColumnFilters[columnFilter].endDate).add(1, 'days').format('YYYY/MM/DD')}` }
                            ];
                        }
                    } else if (columnFilter === 'gross_amount') {
                        filterToApply[columnFilter] = [
                            { gte: this.transfersColumnFilters[columnFilter][0] },
                            { lte: this.transfersColumnFilters[columnFilter][1] }
                        ];
                    } else if (columnFilter === 'key_product') {
                        if (!filterToApply) {
                            filterToApply = {};
                        }
                        let normalize = this.transfersColumnFilters[columnFilter].normalize('NFD');
                        normalize = normalize.replace(/[\u0300-\u036f]/g, '');
                        normalize = normalize.replace(/ /g, '_');
                        filterToApply[columnFilter] = [
                            { in: `%${normalize}%` }
                        ];
                    } else {
                        filterToApply[columnFilter] = [
                            { in: `%${this.transfersColumnFilters[columnFilter]}%` }
                        ];
                    }
                }
            }

            if (sort) {
                this.transferSort.sortBy = sort.sortBy;
                this.transferSort.sortDesc = sort.sortDesc;
            }

            return this.loadTransactions(filterToApply);
        },

        filterColumnsTransactions(filters) {
            this.transfersColumnFilters = filters;
            this.filterTransactions(false);
        },

        moreTransactions(url, scroll) {
            this.$paymentsService.getTransfersPagination(url, {})
                .then(res => {
                    const { transactions } = res.data;
                    this.transfers = this.transfers.concat(transactions);
                    this.transfers.metadata = res.metadata;
                    this.transfers.scroll = scroll;
                    this.keyUpdateTransfers++;
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    this.$toast.error('Error', error);
                });
        },

        filterOperations(filter, sort) {
            if (filter !== false) {
                this.operationsFilter = filter;
            }

            let filterToApply = false;
            switch (this.operationsFilter) {
                case 'historic':
                    filterToApply = {
                        reconciliation_status: [
                            { eq: 'CONCILIADO' }
                        ],
                        has_completed_reconciliation: [
                            { eq: true }
                        ]
                    };
                    break;
                case 'preconciliado':
                    filterToApply = {
                        reconciliation_status: [
                            { eq: 'PRECONCILIADO' }
                        ]
                    };
                    break;
                case 'agrupadas':
                    filterToApply = {
                        has_completed_reconciliation: [
                            { eq: false }
                        ],
                        reconciliation_status: [
                            { or: '', eq: 'CONCILIADO' },
                            { eq: 'AGRUPADO' }
                        ]
                    };
                    break;
                case 'no-agrupadas':
                    filterToApply = {
                        reconciliation_status: [
                            { null: '' }
                        ]

                    };
                    break;
                default:
                case 'all':
                    filterToApply = {
                        has_completed_reconciliation: [
                            { eq: false }
                        ]
                    };
                    break;
            }


            for (const columnFilter in this.operationsColumnFilters) {
                if (this.operationsColumnFilters[columnFilter]) {
                    if (columnFilter === 'request_date') {
                        if (this.operationsColumnFilters[columnFilter].endDate && this.operationsColumnFilters[columnFilter].startDate) {
                            filterToApply[columnFilter] = [
                                { gte: `${this.$moment(this.operationsColumnFilters[columnFilter].startDate).format('YYYY/MM/DD')}` },
                                { lte: `${this.$moment(this.operationsColumnFilters[columnFilter].endDate).add(1, 'days').format('YYYY/MM/DD')}` }
                            ];
                        }
                    } else if (columnFilter === 'gross_amount') {
                        filterToApply[columnFilter] = [
                            { gte: this.operationsColumnFilters[columnFilter][0] },
                            { lte: this.operationsColumnFilters[columnFilter][1] }
                        ];
                    } else if (columnFilter === 'name_product') {
                        let normalize = this.operationsColumnFilters[columnFilter].normalize('NFD');
                        normalize = normalize.replace(/[\u0300-\u036f]/g, '');
                        normalize = normalize.replace(/ /g, '_');
                        filterToApply[columnFilter] = [
                            { in: `%${normalize}%` }
                        ];
                    } else {
                        filterToApply[columnFilter] = [
                            { in: `%${this.operationsColumnFilters[columnFilter]}%` }
                        ];
                    }
                }
            }

            if (sort) {
                this.operationsSort.sortBy = sort.sortBy;
                this.operationsSort.sortDesc = sort.sortDesc;
            }

            return this.loadOperations(filterToApply);
        },

        filterColumnsOperations(filters) {
            this.operationsColumnFilters = filters;
            this.filterOperations(false);
        },

        moreOperations(url, scroll) {
            this.$paymentsService.getOperationsPagination(url, {})
                .then(res => {
                    const { operations } = res.data;
                    this.operations = this.operations.concat(operations);
                    this.operations.metadata = res.metadata;
                    this.operations.scroll = scroll;
                    this.keyUpdateOperations++;
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    this.$toast.error('Error', error);
                });
        },

        showDetails() {
            this.showModal = true;
            this.$bvModal.show(this.modalId);
        },

        hideDetails() {
            this.showModal = false;
            this.$bvModal.hide(this.modalId);
        },

        changeMonitorType(type) {
            this.clearSelection(true);
            this.loading = true;
            this.monitorType = type;
            this.operations = [];
            this.transactions = [];
            this.transfersColumnFilters = {
                transaction_date: '',
                key_product: '',
                concept: '',
                gross_amount: ''
            };
            this.operationsColumnFilters = {
                request_date: '',
                name_product: '',
                gross_amount: '',
                interveners: ''
            };
            switch (type) {
                case 'all':
                    this.transferFilter = 'all';
                    this.operationsFilter = 'all';
                    this.fetchData();
                    break;
                case 'historic':
                    Promise.all([this.filterTransactions('historic'), this.filterOperations('historic')])
                        .finally(() => {
                            this.loading = false;
                        });
                    break;
                default:
                    break;
            }
        },

        setOperationsList(operations) {
            this.operations = operations;
            this.operations.metadata = operations.metadata;
            this.keyUpdateOperations++;
            this.$store.dispatch('conciliationStore/setSuggestions', true);
        },

        setTransfersList(transfers) {
            this.transfers = transfers;
            this.transfers.metadata = transfers.metadata;
            this.keyUpdateTransfers++;
            this.$store.dispatch('conciliationStore/setSuggestions', true);
        },

        setHeightResume(h) {
            this.heightResume = `${h + 15}px`;
        },

        async getOperationsSuggested() {
            try {
                if (this.$store.getters['conciliationStore/disableAll']) {
                    const uuidGroupedSelected = this.$store.getters['conciliationStore/uuidGroupedSelected'];
                    const res = await this.$paymentsService.getReconciliationInfo(uuidGroupedSelected);
                    const { operations } = res.data.reconciliation;
                    operations.map(operation => {
                        operation.reconciliation = {};
                        operation.reconciliation.uuid = res.data.reconciliation.uuid;
                        operation.reconciliation.comment = res.data.reconciliation.comment;
                        operation.reconciliation.status = res.data.reconciliation.status;
                        return operation;
                    });
                    this.operations = operations;
                } else {
                    const transactionsList = this.$store.getters['conciliationStore/transfers'];
                    const uuids = transactionsList.map(x => x.uuid);
                    if (uuids.length < 1) {
                        this.clearSelection();
                        this.$store.dispatch('conciliationStore/disableGroups', false);
                        return false;
                    }
                    const res = await this.$paymentsService.getOperationsSuggested({ transactions: uuids });
                    this.operations = res.data.operations;
                    this.$store.dispatch('conciliationStore/setSuggestions', true);
                }
                this.$store.dispatch('conciliationStore/setSuggestions', true);
                this.keyUpdateOperations++;
            } catch (err) {
                console.error(err);
            }
        },

        async getTransfersSuggested() {
            try {
                if (this.$store.getters['conciliationStore/disableAll']) {
                    const uuidGroupedSelected = this.$store.getters['conciliationStore/uuidGroupedSelected'];
                    const res = await this.$paymentsService.getReconciliationInfo(uuidGroupedSelected);
                    const { transactions } = res.data.reconciliation;
                    transactions.map(transfer => {
                        transfer.reconciliation = {};
                        transfer.reconciliation.uuid = res.data.reconciliation.uuid;
                        transfer.reconciliation.comment = res.data.reconciliation.comment;
                        transfer.reconciliation.status = res.data.reconciliation.status;
                        return transfer;
                    });
                    this.transfers = transactions;
                } else {
                    const operationsList = this.$store.getters['conciliationStore/operations'];
                    const uuids = operationsList.map(x => x.uuid);
                    if (uuids.length < 1) {
                        this.clearSelection();
                        this.$store.dispatch('conciliationStore/disableGroups', false);
                        return false;
                    }
                    const res = await this.$paymentsService.getTransfersSuggested({ operations: uuids });
                    this.transfers = res.data.transactions;
                    this.$store.dispatch('conciliationStore/setSuggestions', true);
                }
                this.$store.dispatch('conciliationStore/setSuggestions', true);
                this.keyUpdateTransfers++;
            } catch (err) {
                console.error(err);
            }
        }
    },

    computed: {
        viewResume() {
            const transfers = this.$store.getters['conciliationStore/transfers'];
            const operations = this.$store.getters['conciliationStore/operations'];

            return transfers.length || operations.length;
        },
        transfersSelected() {
            const transfers = this.$store.getters['conciliationStore/transfers'];
            return transfers;
        },
        areSuggested() {
            return this.$store.getters['conciliationStore/suggestions'];
        },
        groupedSelected() {
            return this.$store.getters['conciliationStore/groupedSelected'];
        }
    },
    /**
     * @override
     */
    beforeDestroy() {
        // Al destruir el componente, se destruyen los listener de eventos en el root
        this.$root.$off('fetch_data', this.fetchData);
        this.$root.$off('filter_transactions', this.filterTransactions);
        this.$root.$off('filter_operations', this.filterOperations);
        this.$root.$off('set_operations', this.setOperationsList);
        this.$root.$off('set_transfers', this.setTransfersList);
        this.$root.$off('more_transactions', this.moreTransactions);
        this.$root.$off('more_operations', this.moreOperations);
        this.$root.$off('height_resume', this.setHeightResume);
        this.$root.$off('get_operations_suggested', this.getOperationsSuggested);
        this.$root.$off('get_transfers_suggested', this.getTransfersSuggested);
        this.$root.$off('filter_columns_transactions', this.filterColumnsTransactions);
        this.$root.$off('filter_columns_operations', this.filterColumnsOperations);
    }
};
